import { createHead } from '@unhead/vue/client';
import type { App } from 'vue';

export function setupUseHead(app: App) {
  const head = createHead();
  app.use(head);
}
